module.exports = __webpack_public_path__ + "img/blue-withdraw.31438854.svg";